import { render, staticRenderFns } from "./OrderDone.vue?vue&type=template&id=56357912&scoped=true&"
import script from "./OrderDone.vue?vue&type=script&lang=js&"
export * from "./OrderDone.vue?vue&type=script&lang=js&"
import style0 from "./OrderDone.vue?vue&type=style&index=0&id=56357912&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56357912",
  null
  
)

export default component.exports